module.exports = __webpack_public_path__ + "static/img/29.5f36fde.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mohu/3/29.png
// module id = rXs1
// module chunks = 0